import { CacheTag, Oss } from '../../index';
import type {
  GetEventsSearchListResponse,
  GetEventsSearchListData,
} from '../../generated/oss';
import { logger } from '@tuic/logger';
import { remember, serializeDataToCacheKey } from '@tuic/cache';

type Options = GetEventsSearchListData['query'];

type Response =
  | {
      status: 'success';
      data: GetEventsSearchListResponse;
    }
  | {
      status: 'error';
      message: string;
    };

export async function getEventsSearchList(
  options: Options,
): Promise<Response> {
  const { data, error } = await Oss.getEventsSearchList({
    query: {
      ...options,
    },
  });

  if (error) {
    logger.error(
      `Could not fetch events search list: ${options?.locale}. Query: ${JSON.stringify(
        options,
      )}`,
    );
    logger.error(error);

    return {
      status: 'error',
      message: 'api error',
    };
  }

  return {
    status: 'success',
    data: data ?? {},
  };
}

export const cachedGetEventsSearchList = (
  options: Options,
): Promise<Response> =>
  remember(
    serializeDataToCacheKey(['oss', 'getEventsSearchList', options]),
    () => getEventsSearchList(options),
    {
      tags: [CacheTag.oss],
      ttl: 600,
      shouldCache: response => response.status === 'success',
    },
  );
